/*
 * Models for reports
 *
 * I think at this point we'll plan to have this represent a report and its configuration parameters, and worry about the data elsewhere
 *
 *
 */

define(["backbone", "messaging/messenger", "configuration/properties", "jquery"], function (
  Backbone,
  Messenger,
  Properties,
  $,
) {
  let analyticsTags = null;
  const ReportModel = {};
  const ARCHIVED_TOPIC_OPTIONS = {
    SHOW_ALL: "show_all",
    SHOW_ARCHIVED: "show_archived",
    SHOW_NON_ARCHIVED: "show_non_archived",
  };

  ReportModel.hrefs = {
    TOPIC_LISTING_BATCH:
      "/topicListing/{language}/{abbreviated}/{showBlankResponses}/{offset}/{batchSize}?touchPointIds={touchpoint}",
  };

  ReportModel.argumentChoice = Backbone.Model.extend({
    name: "SomeChoice",
  });

  ReportModel.argumentChoices = Backbone.Collection.extend({
    model: ReportModel.argumentChoice,
  });

  // noinspection JSUnusedGlobalSymbols
  ReportModel.reportArgument = Backbone.Model.extend({
    paramName: "",
    paramType: "",
    paramValue: "",
    paramUrl: "",
    listItem: "",

    setParamName: function (newHref) {
      this.paramName = newHref;
    },
    setParamType: function (newHref) {
      this.paramType = newHref;
    },
    setParamValue: function (newHref) {
      this.paramValue = newHref;
    },
  });

  ReportModel.reportArguments = Backbone.Collection.extend({
    model: ReportModel.reportArgument,
    addNewEntry: function () {
      const newEntry = new ReportModel.reportArgument();
      this.add(newEntry);
      return newEntry; //return new entry so we can easily manipulate it without searching
    },
  });

  //the basic item - a single report
  // noinspection JSUnusedGlobalSymbols
  ReportModel.report = Backbone.Model.extend({
    defaults: {
      name: "",
      defaultReport: false,
      href: "testing456", //the part of the url after {kbID}/reports
      reportArguments: new ReportModel.reportArguments(),
      type: null,
      options: null,
      isDashboard: false,
      componentReports: null,
      drillDownReport: null,
      description: "This is a helpful report",
      image: "paper_fibers.png",
    },
    reportArguments: function () {
      //make sure we return it in the proper format
      let temp = this.attributes.reportArguments;
      if (temp[0] === undefined) temp = this.attributes.reportArguments.models;
      this.attributes.reportArguments = new ReportModel.reportArguments();
      for (let i = 0; i < temp.length; i++) {
        this.attributes.reportArguments.add(temp[i]);
      }
      return this.attributes.reportArguments;
    },
    _validateDuplicateReportName: function (value) {
      for (let i = 0; i < this.collection.length; i++) {
        const entry = this.collection.at(i);
        if (this !== entry) {
          //don't check the entry against itself
          if (value.toUpperCase() === entry.get("name").toUpperCase()) {
            return $.t("report.validationError");
          }
        }
      }
    },
    validateAttribute: function (attribute, value) {
      if (attribute === "name") {
        return (
          this.validateRequiredValue(value) ||
          this.validateSafeCharacters(value) ||
          this._validateDuplicateReportName(value)
        );
      }
    },
    setName: function (newName) {
      this.name = newName;
    },
    setHref: function (newHref) {
      this.href = newHref;
    },
    setParamName: function (newHref) {
      this.paramName = newHref;
    },
    setParamType: function (newHref) {
      this.paramType = newHref;
    },
    setParamValue: function (newHref) {
      this.paramValue = newHref;
    },
    setType: function (newType) {
      this.type = newType;
    },
    setOptions: function (newOptions) {
      this.options = newOptions;
    },

    idAttribute: "name",
    comparator: function (report) {
      return $.t(report.get("name"));
    },
  });

  ReportModel.reports = Backbone.Collection.extend({
    model: ReportModel.report,
    url: function () {
      const kbId = Messenger.reqres.request("active:kb");
      return Properties.rootURL + "/" + kbId + "/reports";
    },
    comparator: function (report) {
      return $.t(report.get("name"));
    },
    addNewEntry: function () {
      const newEntry = new ReportModel.report();
      this.add(newEntry);
      return newEntry; //return new entry so we can easily manipulate it without searching
    },
  });

  ReportModel.group = Backbone.Model.extend({
    constructor: function () {
      this.reports = new ReportModel.reports();
      Backbone.Model.apply(this, arguments);
    },
    parse: function (response) {
      console.log("in parse");
      this.set("name", response.name);
      this.set("icon", response.icon);
      this.set("order", response.order);
      const reports = new ReportModel.reports();
      for (let i = 0; i < response.reports.length; i++) {
        reports.add(new ReportModel.report(response.reports[i]));
      }
      this.set("reports", reports);
    },
  });

  ReportModel.groups = Backbone.Collection.extend({
    model: ReportModel.group,
    url: function () {
      const kbId = Messenger.reqres.request("active:kb");
      return Properties.rootURL + "/" + kbId + "/reports/groups";
    },
    comparator: function (a, b) {
      return Backbone.numericComparator(a, b, "order");
    },
    addNewEntry: function () {
      const newEntry = new ReportModel.group();
      this.add(newEntry);
      return newEntry; //return new entry so we can easily manipulate it without searching
    },
  });

  ReportModel.analyticsTag = Backbone.Model.extend({
    defaults: {
      value: "",
    },
  });

  ReportModel.analyticsTags = Backbone.Collection.extend({
    model: ReportModel.analyticsTag,
    url: function () {
      const kbId = Messenger.reqres.request("active:kb");
      return Properties.rootURL + "/" + kbId + "/reports/analyticsTags";
    },
    comparator: function (a, b) {
      return Backbone.textComparator(a, b, "value");
    },
  });

  Messenger.reqres.setHandler("topic:listing:count", function (touchPoint, locale) {
    const kbId = Messenger.reqres.request("active:kb");
    const url = `${Properties.rootURL}/${kbId}/reports/topicListingCount/${locale}?touchPointIds=${touchPoint}`;

    const topicCount = new Backbone.Model({});
    topicCount.url = function () {
      return url;
    };
    topicCount.fetch();
    return topicCount;
  });

  //handler to load all the reports
  Messenger.reqres.setHandler("reports", function () {
    console.log("get reps");
    const reps = new ReportModel.reports();
    reps.on("sync", function () {
      this.sort();
    });
    //eventually we'll fetch this from the server, but that is in the far future
    reps.fetch();
    return reps;
  });

  //handler to load report groups
  Messenger.reqres.setHandler("report:groups", function () {
    console.log("get report groups");
    const reps = new ReportModel.groups();
    reps.on("sync", function () {
      this.sort();
    });
    //eventually we'll fetch this from the server, but that is in the far future
    reps.fetch();
    return reps;
  });

  Messenger.reqres.setHandler("report:analyticsTags", function () {
    if (analyticsTags) {
      return analyticsTags;
    }
    analyticsTags = new ReportModel.analyticsTags();
    analyticsTags.on("sync", () => {
      analyticsTags.sort();
    });
    analyticsTags.fetch();
    return analyticsTags;
  });

  Messenger.reqres.setHandler("archivedTopics:options", function () {
    return ARCHIVED_TOPIC_OPTIONS;
  });

  Messenger.reqres.setHandler("archivedTopics:options:default", function () {
    return ARCHIVED_TOPIC_OPTIONS.SHOW_ALL;
  });

  return ReportModel;
});
